import React, {useState} from "react";
import {useParams} from "react-router-dom";
import SignInBaseLayout from "../../common/SignInBaseLayout";
import {NewPasswordDataTo, NewPasswordTo, PasswordSuccessHandler,} from "../forgotpassword/types";
import axios, {AxiosResponse} from "axios";
import EnterNewPasswordForm from "../forgotpassword/EnterNewPasswordForm";
import {EntryPoint} from "../authenticate/types";
import {redirect} from "../authenticate/useAuthenticate";
import {useLxTranslations} from "@lxo-blocks/react";
import {makeLxTranslations} from "@lxo-blocks/react";


const SET_PASSWORD_VIEW_TRANSLATION = makeLxTranslations({
    namespace: "setPasswordViewTranslations",
    translations: {
        CONFIRMATION_TICKET_NOT_VALID: "Der Link ist ungültig oder wurde bereits eingelöst.",
        GENERAL_ERROR_TEXT: "Ihre Anfrage konnte nicht verarbeitet werden!",
    }
});

export default function SetPasswordView(props: any) {
    const {t} = useLxTranslations(SET_PASSWORD_VIEW_TRANSLATION);
    const [currentError, setCurrentError] = useState<string>("");
    const {confirmationTicketId} = useParams<{ confirmationTicketId: string }>();

    const successHandler: PasswordSuccessHandler = {
        onSuccess: (response: EntryPoint) => {
            redirect(response, null);
        },
        onMfa: () => {
        },
        onMfaReset: () => {
        },
        onError: (error: any) => {
            handleError(error);
        },
    }

    const handleError = (error: any) => {
        if (error.response?.data?.IssueList[0]?.i18nKey === "invalid_confirmation_ticket") {
            setCurrentError(t("CONFIRMATION_TICKET_NOT_VALID"));
        } else {
            setCurrentError(t("GENERAL_ERROR_TEXT"));
        }
    }

    async function submitNewPassword(newPassword: NewPasswordTo) {
        let newPasswordDataTo = {
            confirmationId: confirmationTicketId,
            password1: newPassword.password1,
            password2: newPassword.password2,
        }
        return submitData(newPasswordDataTo);
    }

    async function submitData(updatedPasswordDataTo: NewPasswordDataTo) {
        setCurrentError("");
        try {
            let resetResult: AxiosResponse<EntryPoint> = await axios.post("/grld-public/adduser/v100/confirm", updatedPasswordDataTo)
            successHandler.onSuccess(resetResult.data);
        } catch (error) {
            successHandler.onError(error);
        }
    }

    return (
        <SignInBaseLayout headline_i18n={"SET_PASSWORD"} subtitle_i18n={"SET_PASSWORD_subtitle"}>
            <EnterNewPasswordForm successHandler={successHandler} confirmationTicketId={confirmationTicketId}
                                  currentError={currentError} submitMethod={submitNewPassword}/>
        </SignInBaseLayout>
    );
}
